export default __webpack_public_path__ + "static/media/achieve_icon1.2dd6124b.svg";